import { endpointConst } from "./cacheLayerConstants";

const burstCacheConfig = {
  // [endpointConst.getEarliestDeliveryDays]: [endpointConst.productList],
};

const cacheConfig = {
  [endpointConst.geojs]: {
    ttl: 1200000,
  },
  default: {
    ttl: 900000,
  },
};

export { burstCacheConfig, cacheConfig };
